import QueryItem from './QueryItem';

export default QueryItem;
